import type { SvgIconProps } from '~/@mid_ui/icons/svgIcon'
import { SvgIcon } from '~/@mid_ui/icons/svgIcon'

export function NoTransactionsSvg({
  width = 531,
  height = 320,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      {...props}>
      <g clipPath="url(#clip0_3434_32943)">
        <path
          stroke="#3F6EEC"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M36.07 99.41a47.745 47.745 0 01-1.86-13.222M47.473 119.189a47.544 47.544 0 01-5.637-7.144M52.742 123.943a47.181 47.181 0 01-2.062-1.697M94.432 133.985H82.046a47.569 47.569 0 01-26.648-8.122M94.43 38.397c13.186 0 25.145 5.358 33.805 14.022M72.414 39.365c3.112-.64 6.33-.968 9.62-.968M35.86 73.737c3.21-11.863 10.874-21.913 21.099-28.231"></path>
        <path
          fill="#D9E2FB"
          d="M312.055 231.556c0 11.97-9.7 21.664-21.677 21.664H259.56c-2.356 0-4.499.96-6.055 2.497-1.538 1.556-2.499 3.679-2.499 6.034a8.544 8.544 0 008.554 8.549h12.244a9.453 9.453 0 016.686 2.772 9.443 9.443 0 012.774 6.683c0 5.234-4.241 9.472-9.46 9.472H88.861c-5.237 0-9.478-4.238-9.478-9.472 0-5.234 4.241-9.455 9.478-9.455h34.944c2.356 0 4.481-.96 6.037-2.497a8.597 8.597 0 002.499-6.052c0-4.709-3.824-8.531-8.536-8.531h-8.554a21.577 21.577 0 01-15.329-6.353 21.54 21.54 0 01-6.357-15.32c0-11.952 9.7-21.647 21.677-21.647h175.127c5.984 0 11.399 2.426 15.329 6.354a21.527 21.527 0 016.357 15.302zM157.732 50.251c0 3.164-1.29 6.034-3.361 8.105l-3.61 3.607-16.227 16.218-16.227-16.218-3.61-3.608a11.433 11.433 0 01-3.361-8.104c0-6.335 5.139-11.472 11.479-11.472a11.45 11.45 0 018.109 3.36l3.61 3.607 3.61-3.608a11.448 11.448 0 018.109-3.359c6.331 0 11.47 5.136 11.479 11.472z"></path>
        <path
          stroke="#3F6EEC"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M161.461 65.233a3.93 3.93 0 01-1.156 2.79l-1.244 1.244-5.584 5.58-5.584-5.58-1.245-1.244a3.935 3.935 0 01-1.156-2.79 3.95 3.95 0 016.74-2.79l1.245 1.243 1.245-1.244a3.949 3.949 0 016.739 2.79zM34.11 173.147c-5.691 0-10.297 8.024-10.297 17.914 0-9.89-4.615-17.914-10.305-17.914 5.69 0 10.305-8.015 10.305-17.915 0 9.891 4.606 17.915 10.296 17.915z"></path>
        <path
          fill="#F0EEEE"
          d="M355.513 275.844c0 24.037-19.49 43.524-43.524 43.524h-91.395v-87.022h91.395c24.034 0 43.524 19.478 43.524 43.498z"></path>
        <mask
          id="mask0_3434_32943"
          style={{ maskType: 'luminance' }}
          width="136"
          height="88"
          x="220"
          y="232"
          maskUnits="userSpaceOnUse">
          <path
            fill="#fff"
            d="M355.513 275.844c0 24.037-19.49 43.524-43.524 43.524h-91.395v-87.022h91.395c24.034 0 43.524 19.478 43.524 43.498z"></path>
        </mask>
        <g
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          mask="url(#mask0_3434_32943)">
          <path d="M220.586 232.346h134.928M220.586 246.848h134.928M220.586 261.352h134.928M220.586 275.852h134.928M220.586 290.354h134.928M220.586 304.865h134.928M220.586 319.367h134.928"></path>
        </g>
        <path
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M355.513 275.844c0 24.037-19.49 43.524-43.524 43.524h-91.395v-87.022h91.395c24.034 0 43.524 19.478 43.524 43.498z"></path>
        <path
          fill="#fff"
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M220.572 319.359c24.042 0 43.533-19.479 43.533-43.507s-19.491-43.506-43.533-43.506c-24.043 0-43.533 19.478-43.533 43.506s19.49 43.507 43.533 43.507z"></path>
        <path
          fill="#F0EEEE"
          d="M220.57 241.285c19.099 0 34.588 15.48 34.588 34.567l-34.588-34.567z"></path>
        <path
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M220.57 241.285c19.099 0 34.588 15.48 34.588 34.567"></path>
        <path
          stroke="#3F6EEC"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M.633 222.66v15h48.352M56.477 237.66h25.216M45.078 242.566h25.207M87.375 237.66h10.616M174.859 259.547a49.173 49.173 0 011.29-3.235M172.055 275.853c0-4.292.56-8.45 1.6-12.414M264.678 296.096a48.73 48.73 0 01-11.959 16.084M183.133 245.009c8.9-10.779 22.362-17.648 37.442-17.648"></path>
        <path
          fill="#D9E2FB"
          d="M441.933 84.915c0-11.97-9.701-21.664-21.678-21.664h-30.818a8.605 8.605 0 01-6.055-2.497 8.543 8.543 0 016.055-14.582h12.244a9.452 9.452 0 006.686-2.773 9.443 9.443 0 002.774-6.682c0-5.234-4.241-9.473-9.46-9.473h-65.468c-5.237 0-9.479 4.239-9.479 9.473 0 5.234 4.242 9.455 9.479 9.455h21.126c2.356 0 4.481.96 6.037 2.497a8.596 8.596 0 012.499 6.051c0 4.71-3.824 8.53-8.536 8.53h-8.554a21.581 21.581 0 00-15.329 6.355 21.539 21.539 0 00-6.357 15.32c0 11.951 9.701 21.646 21.677 21.646h71.479c5.984 0 11.399-2.426 15.329-6.354a21.526 21.526 0 006.357-15.302h-.008z"></path>
        <path
          fill="#9C9C9C"
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M525.024 209.928h-108.68v22.411h108.68v-22.411z"></path>
        <path
          fill="#fff"
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M416.353 209.928H5.859v22.411h410.494v-22.411zM457.846 80.287h-102.51v129.641h102.51V80.288z"></path>
        <path
          fill="#F0EEEE"
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M457.843 209.928h42.751V80.288h-42.751v129.64z"></path>
        <path
          fill="#fff"
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M457.852 74.537H351.883v5.758h105.969v-5.758z"></path>
        <path
          fill="#F0EEEE"
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M457.838 80.287h46.209V74.53h-46.209v5.758z"></path>
        <path
          fill="#fff"
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M457.843 59.28h-23.812v15.257h23.812V59.279z"></path>
        <path
          fill="#F0EEEE"
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M457.853 74.537h10.225V59.28h-10.225v15.257zM398.787 93.314h-33.849v24.837h33.849V93.314zM448.241 93.314h-33.85v24.837h33.85V93.314zM398.787 130.637h-33.849v24.837h33.849v-24.837zM448.241 130.637h-33.85v24.837h33.85v-24.837zM398.787 167.959h-33.849v24.837h33.849v-24.837zM448.241 167.959h-33.85v24.837h33.85v-24.837zM474.839 118.148h8.794V93.312h-8.794v24.836zM474.839 155.473h8.794v-24.837h-8.794v24.837zM474.839 192.795h8.794v-24.837h-8.794v24.837z"></path>
        <path
          fill="#fff"
          d="M143.52 193.879H56.445v16.048h87.075v-16.048z"></path>
        <mask
          id="mask1_3434_32943"
          style={{ maskType: 'luminance' }}
          width="88"
          height="17"
          x="56"
          y="193"
          maskUnits="userSpaceOnUse">
          <path
            fill="#fff"
            d="M143.52 193.879H56.445v16.048h87.075v-16.048z"></path>
        </mask>
        <g
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          mask="url(#mask1_3434_32943)">
          <path d="M56.445 209.928v-22.473M70.96 209.928v-22.473M85.46 209.928v-22.473M99.984 209.928v-22.473M114.5 209.928v-22.473M129.008 209.928v-22.473M143.523 209.928v-22.473"></path>
        </g>
        <path
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M143.52 193.879H56.445v16.048h87.075v-16.048z"></path>
        <path
          fill="#fff"
          d="M132.153 177.84H45.078v16.048h87.075V177.84z"></path>
        <mask
          id="mask2_3434_32943"
          style={{ maskType: 'luminance' }}
          width="88"
          height="17"
          x="45"
          y="177"
          maskUnits="userSpaceOnUse">
          <path
            fill="#fff"
            d="M132.153 177.84H45.078v16.048h87.075V177.84z"></path>
        </mask>
        <g
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          mask="url(#mask2_3434_32943)">
          <path d="M45.078 193.88v-22.464M59.594 193.88v-22.464M74.094 193.88v-22.464M88.617 193.88v-22.464M103.133 193.88v-22.464M117.641 193.88v-22.464M132.156 193.88v-22.464"></path>
        </g>
        <path
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M132.153 177.84H45.078v16.048h87.075V177.84z"></path>
        <path
          fill="#fff"
          d="M138.309 161.791H51.234v16.048h87.075v-16.048z"></path>
        <mask
          id="mask3_3434_32943"
          style={{ maskType: 'luminance' }}
          width="88"
          height="17"
          x="51"
          y="161"
          maskUnits="userSpaceOnUse">
          <path
            fill="#fff"
            d="M138.309 161.791H51.234v16.048h87.075v-16.048z"></path>
        </mask>
        <g
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          mask="url(#mask3_3434_32943)">
          <path d="M51.234 177.84v-22.473M65.75 177.84v-22.473M80.25 177.84v-22.473M94.766 177.84v-22.473M109.281 177.84v-22.473M123.789 177.84v-22.473M138.312 177.84v-22.473"></path>
        </g>
        <path
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M138.309 161.791H51.234v16.048h87.075v-16.048z"></path>
        <path
          fill="#fff"
          d="M132.153 145.742H45.078v16.049h87.075v-16.049z"></path>
        <mask
          id="mask4_3434_32943"
          style={{ maskType: 'luminance' }}
          width="88"
          height="17"
          x="45"
          y="145"
          maskUnits="userSpaceOnUse">
          <path
            fill="#fff"
            d="M132.153 145.742H45.078v16.049h87.075v-16.049z"></path>
        </mask>
        <g
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          mask="url(#mask4_3434_32943)">
          <path d="M45.078 161.791v-22.473M59.594 161.791v-22.473M74.094 161.791v-22.473M88.617 161.791v-22.473M103.133 161.791v-22.473M117.641 161.791v-22.473M132.156 161.791v-22.473"></path>
        </g>
        <path
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M132.153 145.742H45.078v16.049h87.075v-16.049z"></path>
        <path
          fill="#fff"
          d="M125.231 129.703H38.156v16.049h87.075v-16.049z"></path>
        <mask
          id="mask5_3434_32943"
          style={{ maskType: 'luminance' }}
          width="88"
          height="17"
          x="38"
          y="129"
          maskUnits="userSpaceOnUse">
          <path
            fill="#fff"
            d="M125.231 129.703H38.156v16.049h87.075v-16.049z"></path>
        </mask>
        <g
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          mask="url(#mask5_3434_32943)">
          <path d="M38.156 145.744v-22.465M52.672 145.744v-22.465M67.188 145.744v-22.465M81.695 145.744v-22.465M96.21 145.744v-22.465M110.719 145.744v-22.465M125.234 145.744v-22.465"></path>
        </g>
        <path
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M125.231 129.703H38.156v16.049h87.075v-16.049z"></path>
        <path
          fill="#DBDADA"
          d="M94.766 129.701c24.042 0 43.541-19.478 43.541-43.515 0-24.038-19.49-43.516-43.541-43.516h-13.07v87.022h13.07v.009z"></path>
        <mask
          id="mask6_3434_32943"
          style={{ maskType: 'luminance' }}
          width="58"
          height="88"
          x="81"
          y="42"
          maskUnits="userSpaceOnUse">
          <path
            fill="#fff"
            d="M94.766 129.701c24.042 0 43.541-19.478 43.541-43.515 0-24.038-19.49-43.516-43.541-43.516h-13.07v87.022h13.07v.009z"></path>
        </mask>
        <g
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          mask="url(#mask6_3434_32943)">
          <path d="M32.344 42.678h152.204M32.344 57.18h152.204M32.344 71.684h152.204M32.344 86.184h152.204M32.344 100.686h152.204M32.344 115.197h152.204M32.344 129.699h152.204"></path>
        </g>
        <path
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M94.766 129.701c24.042 0 43.541-19.478 43.541-43.515 0-24.038-19.49-43.516-43.541-43.516h-13.07v87.022h13.07v.009z"></path>
        <path
          fill="#fff"
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M81.698 129.701c24.047 0 43.542-19.482 43.542-43.515 0-24.034-19.495-43.516-43.542-43.516S38.156 62.153 38.156 86.186c0 24.033 19.495 43.515 43.542 43.515z"></path>
        <path
          fill="#F0EEEE"
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M81.695 123.89c20.836 0 37.727-16.88 37.727-37.704 0-20.823-16.891-37.704-37.727-37.704-20.835 0-37.726 16.881-37.726 37.704 0 20.824 16.89 37.704 37.726 37.704z"></path>
        <path
          fill="#3F6EEC"
          d="M108.001 81.069c0-7.18-5.824-13-13.009-13a12.973 12.973 0 00-9.194 3.803L81.7 75.968 77.6 71.872a12.93 12.93 0 00-9.193-3.804c-7.185 0-13.009 5.82-13.009 13 0 3.59 1.459 6.843 3.806 9.19l4.099 4.096L81.7 112.739l18.396-18.385 4.099-4.097a12.938 12.938 0 003.806-9.188zm-14.316 6.887l-12.119 12.112-7.362-7.358-3.717-3.715a4.032 4.032 0 01-.755-1.057 3.95 3.95 0 016.34-4.523l3.805 3.803 1.698 1.697 1.867-1.866 4.668-4.665 4.1-4.097a3.938 3.938 0 012.96-1.333 3.949 3.949 0 013.948 3.946 3.965 3.965 0 01-1.334 2.96l-4.099 4.096z"></path>
        <path
          fill="#D9E2FB"
          d="M450.942 27.254h-20.229a6.906 6.906 0 00-6.908 6.904v5.119a6.906 6.906 0 006.908 6.904h20.229a6.906 6.906 0 006.908-6.904v-5.119a6.906 6.906 0 00-6.908-6.904z"></path>
        <path
          stroke="#3F6EEC"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M530.373 213.632v-9.046H514.68M473.545 57.947v-3.732h-15.693"></path>
        <path
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M220.575 319.369h-40.208M174.857 319.369h-4.295M352.894 319.369h-47.152M366.925 319.369h-8.011"></path>
        <path
          stroke="#3F6EEC"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M411.604 18.35c-7.078 0-12.822 8.22-12.822 18.359 0-10.14-5.743-18.36-12.821-18.36 7.078 0 12.821-8.21 12.821-18.349 0 10.14 5.736 18.35 12.822 18.35z"></path>
        <path
          fill="#fff"
          d="M48.868 35.945c-3.538 0-6.41 4.114-6.41 9.18 0-5.066-2.872-9.18-6.411-9.18 3.539 0 6.41-4.105 6.41-9.18 0 5.066 2.873 9.18 6.411 9.18z"></path>
        <path
          fill="#D9E2FB"
          d="M39.728 49.797c-5.566 0-10.083 6.47-10.083 14.44 0-7.97-4.516-14.44-10.082-14.44 5.566 0 10.082-6.46 10.082-14.44 0 7.971 4.517 14.44 10.083 14.44z"></path>
        <path
          fill="#DBDADA"
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M220.578 304.867c16.033 0 29.03-12.99 29.03-29.014 0-16.023-12.997-29.013-29.03-29.013-16.034 0-29.031 12.99-29.031 29.013 0 16.024 12.997 29.014 29.031 29.014z"></path>
        <path
          stroke="#1D1D1B"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M245.72 261.352h-50.29M249.608 275.854h-58.061M245.71 290.357h-50.272"></path>
        <path
          stroke="#3F6EEC"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M388.156 237.66h52.113M288.518 204.586h-35.815M245.711 204.586h-6.18"></path>
        <path
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="1.42"
          d="M114.416 86.187c0-18.065-14.653-32.7-32.72-32.7"></path>
      </g>
      <defs>
        <clipPath id="clip0_3434_32943">
          <path fill="#fff" d="M0 0H531V320H0z"></path>
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
